export default {
  props: ['studyId'],
  data(){
    return{
      textareaLine:'0',
      table:{
        id:'0',
        name:'发帖测试1',
      },
      DiscussionForum:{
        content:'',
        id:'',
        // total:'10',
        title:'',
        
      },
      comment:[{
        user_name:'',
        created_at:'',
        content:'',
      }],
      posting:{
        FloorMasterName:'',
        FloorMasterId:'',
        FloorMasterTime:'',
        FloorMasterDesc:'',
      },
      Imgurl:require('../../assets/images/avatar.jpg'),
      //分页
      total:0,//总条数
      offset:0,
      length:10,//显示条数
      next1:1,
      prev:'',
      pager:'',
      next:'',
      //只看自己标志
      ziji:false,
      //用户id
      userId:'',
      // 产品id
      product_id: ''
    }
  }, 
  methods:{
    //分页函数
    paging(res){
      let userid
      if(this.ziji){
        userid = this.userId
      }
      this.offset = (res-1) * this.length
      let next = res
      this.$post('comment/get_comment_by_theme',{
        token:this.$store.state.id,
        discuss_theme_id:this.DiscussionForum.id, 
        user_id:userid,
        offset:this.offset, 
        length:this.length,
        product_id: this.product_id
      }).then(res=>{
        this.comment =  res.data.result.data
        this.total = res.data.result.total
        this.next1 = next
      })
    },

    //查询看自己
    handleCheckedCitiesChange(value) {
      let userid 
      this.next1 = 1
      if(this.ziji){
        userid = this.userId//查看自己
      }else{
       //查看自己所有
      }

      this.$post('comment/get_comment_by_theme',{
        token:this.$store.state.id,
        discuss_theme_id:this.DiscussionForum.id, 
        user_id : userid,
        offset:this.offset, 
        length:this.length,
        product_id: this.product_id
      }).then(res=>{
        this.comment =  res.data.result.data
        this.total = res.data.result.total
        this.next1 =  1
      })
     
    },

    // 正确提示
    open2() {
      this.$message({
        message: '发表成功！',
        type: 'success'
      });
    },
    // 错误提示
    open4() {
      this.$message.error('内容不能为空！');
    },
    textLine(){
      let str = document.getElementsByName("input")[0].value;
      if (str == null) return 0;
      if (typeof str != "string"){
        str += "";
      }
      let length =  str.replace(/[^\x00-\xff]/g,"ab").length;
      // console.log(length)
      this.textareaLine = Math.floor(length/2)
    },
    Posting(){
      let desc = document.getElementsByName("input")[0].value;
      let date =new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      //alert(year+'-'+month+'-'+day+'-'+hour+':'+minute+':'+second);
      // console.log(desc)
      if(desc!="" && desc!=null && desc.length>14){
        this.$post('comment/create',{
          token:this.$store.state.id, 
          discuss_theme_id: this.DiscussionForum.id, 
          content :desc,
          product_id: this.product_id
        }).then(res=>{
          // console.log(res.data.status)
          if(res.data.status=="success"){
              this.open2()
              this.getData()
              document.getElementsByName("input")[0].value = '';
              this.$emit('closeMain',2);//向父组件传值
          }
        })
      }else{
        if(!desc){
          this.$message.error('内容不能为空！');
        }else{
          this.$message.error('内容不能少于15个字！');
        }
      }

    },
    //获取资源
    getData(){
      this.$post('discuss_theme/get_with_comment',{
          token:this.$store.state.id,
          resource_id:this.studyId
      }).then(res=>{
        // console.log('当前资源数据id:',this.studyId)
        // console.log(res.data.result)
        this.DiscussionForum = res.data.result;  
        // console.log( '讨论题',this.DiscussionForum)
        this.$post('comment/get_comment_by_theme',{
          token:this.$store.state.id,
          discuss_theme_id:this.DiscussionForum.id, 
          offset:this.offset, 
          length:this.length,
          product_id: this.product_id
        }).then(res=>{
          // console.log(res.data)
          this.total = res.data.result.total
          // console.log(this.total )
          this.comment =  res.data.result.data
        })
      })
    },
    //获取用户id
    getUserId(){
        this.$post('users/profile',{
          token:this.$store.state.id,
        }).then(res=>{
          this.userId = res.data.result.id
        })
    }
  },
  mounted(){
    this.getUserId();
    this.getData();
    this.product_id = this.$route.query.product_id
  },
  watch:{
    

  }
}